import type { ReactNode } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../utils/cx.js";

export interface PopoverProps {
  content: ReactNode;
  title?: ReactNode;
  trigger?: "click" | "hover";
  placement?: "top" | "bottom" | "left" | "right";
  children: ReactNode;
  className?: string;
}

export function Popover({ content, title, placement = "bottom", children, className }: PopoverProps) {
  return (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger asChild>
        <span className="inline-flex">{children}</span>
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          side={placement}
          sideOffset={6}
          className={cn(
            "z-[1200] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
            className,
          )}
        >
          {title != null && <div className="mb-2 text-sm font-semibold">{title}</div>}
          {content}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
